import { render, staticRenderFns } from "./TimeAndMoney.vue?vue&type=template&id=b6a138cc&scoped=true&"
import script from "./TimeAndMoney.vue?vue&type=script&lang=js&"
export * from "./TimeAndMoney.vue?vue&type=script&lang=js&"
import style0 from "./TimeAndMoney.vue?vue&type=style&index=0&id=b6a138cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a138cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a138cc')) {
      api.createRecord('b6a138cc', component.options)
    } else {
      api.reload('b6a138cc', component.options)
    }
    module.hot.accept("./TimeAndMoney.vue?vue&type=template&id=b6a138cc&scoped=true&", function () {
      api.rerender('b6a138cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/TimeAndMoney.vue"
export default component.exports